import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type ManufacturerFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<ManufacturerFormSchema> = {
  id: -1,
  name: '',
  manufacturer_number: '',
  status: defaultStatus,
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/manufacturers', name: 'Manufacturers' },
];
